import { Eyebrow, MaskReveal, Reveal } from "../reveal";

const features = [
  {
    id: "dining",
    title: "Auburn Dining",
    copy: "Explore restaurants and local businesses.",
  },
  {
    id: "wine",
    title: "Wine Country",
    copy: "Discover Sierra Foothills wineries.",
  },
  {
    id: "beer",
    title: "Local Beer",
    copy: "Explore Auburn's brewery scene.",
  },
];

export function LocalFlavor() {
  return (
    <section
      id="local-flavor"
      aria-labelledby="local-flavor-heading"
      className="bg-background py-16 md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>Taste the Foothills</Eyebrow>
        </Reveal>
        <h2 id="local-flavor-heading" className="display-lg mt-6 max-w-[14ch]">
          <MaskReveal>Eat. Sip. Discover.</MaskReveal>
        </h2>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-muted-foreground">
            Plan transportation responsibly when visiting tasting rooms, wineries or local beer
            destinations.
          </p>
        </Reveal>

        <ul className="mt-10 grid gap-4 md:grid-cols-3">
          {features.map((item, i) => (
            <li key={item.id}>
              <Reveal delay={i * 0.07} className="h-full">
                <article className="group relative aspect-[3/4] overflow-hidden bg-primary">
                  <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/90 via-forest-deep/30 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-7 text-primary-foreground">
                    <h3 className="font-display text-3xl tracking-tight">{item.title}</h3>
                    <p className="mt-3 text-sm text-primary-foreground/80">{item.copy}</p>
                  </div>
                </article>
              </Reveal>
            </li>
          ))}
        </ul>

        <Reveal delay={0.1}>
          <a
            href="#destination-explorer"
            className="eyebrow mt-8 inline-flex text-primary"
            onClick={(e) => {
              e.preventDefault();
              document
                .getElementById("destination-explorer")
                ?.scrollIntoView({ behavior: "smooth" });
              window.dispatchEvent(
                new CustomEvent("nearby-filter", { detail: { category: "Food & Drink" } }),
              );
            }}
          >
            Explore Local Flavor
          </a>
        </Reveal>
      </div>
    </section>
  );
}
